import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useEffect, useState } from 'react';
import { Select, Space } from 'udesk-ui';

const Template = (props) => {
    const { onChange, value = {}, searchTasks, inspectDataSource, sdkOptions } = props;
    const { gradeOperator, inspectionGradeId } = value;
    const [tasks, setTasks] = useState<any[]>([]);
    const [ratingOptions, setRatingOptions] = useState<any[]>([]);
    const [taskId, setTaskId] = useState<number | undefined>(undefined);

    const onSelect = (key, v) => {
        onChange({
            ...value,
            [key]: v,
        });
    };

    const onTaskSelected = (taskId) => {
        setTaskId(taskId);
        onChange({});
        if (!taskId) {
            searchTasks({ inspectDataSource }, (resp) => {
                setTasks(resp.data?.map?.((i) => ({ label: i.name, value: i.id })) ?? []);
            });
            setRatingOptions([]);
            return;
        }
        Udesk.business.sdkAjax
            .get(`open_api_v1/inspectionGrades/${taskId}`, sdkOptions, { props })
            .then(
                (resp) => {
                    setRatingOptions(
                        resp.data?.map?.((i) => ({ label: i.gradeName, value: i.id })) ?? []
                    );
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg ||
                            /* 接口请求异常，请稍后再试 */ UdeskLocales['current'].pages
                                .appealCheckingTask.sdk.index
                                .interfaceRequestExceptionPleaseTryAgainLater
                    );
                }
            );
    };
    useEffect(() => {
        if (inspectDataSource === null) return;
        searchTasks({ inspectDataSource }, (resp) => {
            setTasks(resp.data?.map?.((i) => ({ label: i.name, value: i.id })) ?? []);
        });
    }, [inspectDataSource]);

    return (
        <Space>
            <Select
                onSearch={(value) => {
                    searchTasks({ keywords: value, inspectDataSource }, (resp) => {
                        setTasks(resp.data?.map?.((i) => ({ label: i.name, value: i.id })) ?? []);
                    });
                }}
                onChange={onTaskSelected}
                value={taskId}
                style={{ width: 120 }}
                options={tasks}
                filterOption={false}
                defaultActiveFirstOption={false}
                showSearch
                allowClear
            ></Select>
            <Select
                onChange={onSelect.bind(null, 'gradeOperator')}
                value={gradeOperator}
                style={{ width: 100 }}
                options={Udesk.enums.ratingOptions.map((i) => ({ label: i.name, value: i.id }))}
            ></Select>
            <Select
                onChange={onSelect.bind(null, 'inspectionGradeId')}
                value={inspectionGradeId}
                style={{ width: 120 }}
                options={ratingOptions}
            ></Select>
        </Space>
    );
};

export default Template;
